<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getAllItemPriceList", "صيدلية");

    this.$store.dispatch("lookups/getDoctors");
  },
  computed: {
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },

  },
  data() {
    return {
      appointments: [],
      patient: {
        fullName: null,
        fileNo: null,
      },
      patients: [],

      selectedPatient: {
        fullName: null,
        fileNo: null
      },
      showResult: false,
      showBtn: false,
      dialog: false,
      searchTrem: null,
      //------------------

      // appointments: [],
      // formDialog: false,
      vm: {
        doctorId: null,
        patientId: null,
        appointmentId: null,
        appointmentDate: null,
        items: []
      },
      medicine: {
        serviceName: null,
        quantity: null,
      },
      indexItem: null,
      editFlag: false,
      headers: [
        { text: 'اسم الدواء', value: 'serviceName' },
        { text: 'الكمية', value: 'quantity' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    getAppointments() {
      // this.vm.items =[];
      this.appointments = [];
      this.vm.appointmentDate = null;
      this.$store
        .dispatch("invoicesAnalysis/getAppointments", {
          patientId: this.vm.patientId,
          doctorId: this.vm.doctorId,
        })
        .then((res) => {
          this.appointments = res;
        })
        .catch(() => { });
    },

    confirm() {
      this.$refs.form.validate().then(valid => {
        if (valid) {
          if (this.vm.items.length == 0) {
            showAlert(`يجب ادخال عنصر واحد على الاقل`);
            return false;
          }
          this.vm.appointmentDate = this.appointments.find(x => x.value == this.vm.appointmentId).label

          this.$store
            .dispatch("doctorPrescriptions/add", this.vm)
            .then(() => {
              this.back();
            })
            .catch(() => { });
        } else {
          showAlert(`الرجاء التحقق من تعبئة جميع الحقول  `);

        }
      });

    },

    AddItem() {
      if (this.medicine.serviceName == null) {
        showAlert(`يجب اختيار الدواء `);
        return false;
      } else if (this.medicine.quantity == null) {
        showAlert(`يجب ادخال الكمية   `);
        return false;
      }

      let isFound = false;
      this.vm.items.forEach(element => {
        if (element.serviceName == this.medicine.serviceName) {
          showAlert(`الدواء مضاف مسبقا`);
          isFound = true;
        }
      });

      if (isFound) {
        showAlert(`الدواء مضاف مسبقا`);
        return false;
      }
      let medicine = this.itemPriceList.find(x => x.itemName == this.medicine.serviceName);
      this.vm.items.push({
        serviceName: this.medicine.serviceName,
        serviceCode: medicine.itemCode,
        quantity: this.medicine.quantity,
        price: medicine.price
      });

      this.medicine.serviceName = null;
      this.medicine.quantity = null;
      // this.stock = [];

      this.$refs.form.reset();
    },
    removeItem(index) {
      this.vm.items.splice(index, 1);
    },
    back() {
      this.$emit("back");
    },
    // ----------------------------------------
    SearchPatient() {
      this.showResult = false;
      this.patients = [];
      this.selectedPatient.fullName = null;
      this.selectedPatient.fileNo = null;
      this.vm = {
        patientId: null,
        invoiceDate: null,
        appointmentId: null,
        // invoiceTypeId: null,
        items: [],
        // analysis: []
      };
      if (this.searchTrem == null || this.searchTrem == "" || this.searchTrem.length < 9) {
        showAlert(`الرجاء ادخال رقم الهاتف`);
        return false;
      }

      this.$store
        .dispatch("appointments/search", { searchTrem: this.searchTrem })
        .then((res) => {

          if (res.statusCode == 1) {
            this.showResult = true
            this.patients = res.patients;
            this.dialog = true;
          }
        })
        .catch(() => { });
    },
    confirmDialog() {
      let that = this;
      this.patients.forEach((el) => {
        if (that.vm.patientId == el.id) {

          that.selectedPatient = el
          return el
        }
      });

      this.dialog = false
    },
  },
};
</script>